// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"numbers-0"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M9 19H15C15.5523 19 16 18.5523 16 18V6C16 5.44772 15.5523 5 15 5H9C8.44772 5 8 5.44772 8 6V18C8 18.5523 8.44772 19 9 19Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Numbers0Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'numbers-0',
    ref,
    icon: element,
  },
));

Numbers0Icon.displayName = 'Numbers0Icon';

export default Numbers0Icon;
